import React from 'react';
import { PageData } from './PageData';

const PageDataContext = React.createContext<PageData>({});

export const PageDataContextProvider = PageDataContext.Provider;

export const usePageData = <T extends keyof PageData>(key: T): PageData[T] => {
  return React.useContext(PageDataContext)[key];
};
